namespace nsc {
    $("select.form-control").wrap("<div class='select-wrapper'/>");

    jQuery.validator.addMethod("pattern", function (this: JQueryValidation.Validator, value, element, param) {
        if (this.optional(element)) {
            return true;
        }
        if (typeof param === "string") {
            param = new RegExp("^(?:" + param + ")$");
        }
        return param.test(value);
    }, "Invalid format.");

    function highlightInvalidInput(input: HTMLInputElement) {
        if (typeof input.setCustomValidity !== "function") {
            return;
        }

        input.setCustomValidity("invalid");
    }

    function unhighlightInvalidInput(input: HTMLInputElement) {
        if (typeof input.setCustomValidity !== "function") {
            return;
        }

        input.setCustomValidity("");
    }

    function placeErrorLabel($error: JQuery, $element: JQuery) {
        $element.closest(".form-group").append($error);
    }

    jQuery.validator.setDefaults({
        onsubmit: false,
        onkeyup: false,
        errorClass: "invalid-feedback",
        highlight: highlightInvalidInput,
        unhighlight: unhighlightInvalidInput,
        errorPlacement: placeErrorLabel
    });

    function focusFirstInvalidInput(this: JQuery<Element>) {
        const $group = $("label.invalid-feedback:visible")
            .first()
            .closest(".form-group");

        nsc.scrollToElement($group[0]);
        $(":input[name]", $group).focus();
    }

    function formSubmitListener(this: HTMLFormElement, event: Event) {
        const $form = $(this);

        event.preventDefault();

        if ($form.valid()) {
            this.classList.remove("was-validated");
            return;
        }


        this.classList.add("was-validated");
        event.stopImmediatePropagation();

        setTimeout(focusFirstInvalidInput.bind($form), 0);
    }

    function telephoneChangeListener(this: HTMLInputElement, event: Event) {
        const pattern = new RegExp("^" + this.pattern + "$");

        if (!pattern.test(this.value)) {
            return;
        }

        const value = this.value.replace(/[\(\) \.-]/g, "");

        if (!/^\d{10}$/.test(value)) {
            return;
        }

        const areaCode = value.substr(0, 3);
        const part1 = value.substr(3, 3);
        const part2 = value.substr(6, 4);

        let formatted = "(" + areaCode + ")";

        if (part1 !== "") {
            formatted += " " + part1;
        }

        if (part2 !== "") {
            formatted += "-" + part2;
        }

        this.value = formatted;
    }

    $("input[type=tel][pattern]").on("change", telephoneChangeListener);

    export function activateWizardPage(selector: string, scrollAnchorSelector?: string) {
        const $deactivate = $(".wizard-page.active");
        const $activate = $(selector);

        if ($deactivate.length === 0) {
            $activate.addClass("active");
            return;
        }

        const transitionEnd = (event: JQueryEventObject) => {
            const originalEvent = event.originalEvent;

            if (originalEvent instanceof TransitionEvent && originalEvent.propertyName !== "opacity") {
                return;
            }

            const $scrollAnchor = (scrollAnchorSelector !== undefined)
                ? $(scrollAnchorSelector)
                : $activate;

            $deactivate.removeClass("active");

            $activate.css("opacity", 0)
                .addClass("active")
                .outerHeight();

            scrollToElement($scrollAnchor[0]);

            $activate.css("opacity", 1);

            $deactivate.off("transitionend.opacity");
        };

        $deactivate.on("transitionend.opacity", transitionEnd);
        $deactivate.css("opacity", 0);

        if (!TransitionEvent) {
            $deactivate.triggerHandler("transitionend.opacity");
        }
    }

    function getReCaptchaAction(url: string): string {
        const action = url
            .replace(/^.*\//, '')
            .replace(/\.cfm$/, '')
            .replace(/[^a-zA-Z0-9_]/g, '');
        return action;
    }

    export function postForm(form: HTMLFormElement, url: string): Promise<any> {
        const key = document.body.dataset.recaptchaSiteKey;

        if (!key) {
            throw new Error("missing [data-recaptcha-site-key] on body element");
        }

        const enabled = /^(yes|true|on|1)$/i
            .test(document.body.dataset.recaptchaEnabled ?? "false");

        const $buttons = $(".form-buttons button.btn", form).not(":disabled");

        $buttons.attr("disabled", "");

        // Don't let users do anything while the form submission's in progress
        showBackdrop();

        let data = $(":input[name]", form)
            .not("[data-ignore]")
            // .not("[name^=_]") // Ignore "internal" inputs
            .serialize();

        return new Promise((resolve, reject) => {
            if (!enabled) {
                jQuery.post(url, data)
                    .then(resolve)
                    .catch(reject);
                return;
            }
            grecaptcha.ready(() => {
                const action = getReCaptchaAction(url);
                const tokenPromise = grecaptcha.execute(key, { action });
                tokenPromise.then(token => {
                    data += "&recaptcha_token=";
                    data += encodeURIComponent(token);
                    return jQuery.post(url, data);
                }).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        }).finally(() => {
            $buttons.removeAttr("disabled");
            hideBackdrop();
        });
    }

    export function populateForm(form: HTMLFormElement, data: Record<string, any>) {
        for (let i = 0; i < form.elements.length; i++) {
            const input = form.elements[i] as HTMLInputElement;
            const name = input.dataset.property || input.name;

            if (data[name] === undefined) {
                continue;
            }

            if (input.type === "checkbox") {
                const inputValue = input.value.replace(/%2C/g, ",");

                if (data[name] instanceof Array) {
                    for (const value of data[name]) {
                        if (inputValue === String(value)) {
                            input.checked = true;
                            break;
                        }
                    }
                } else {
                    input.checked = (inputValue === String(data[name]));
                }
            } else if (input.type === "radio") {
                let value = String(data[name]);

                if (value === "true") {
                    value = "Yes";
                } else if (value === "false") {
                    value = "No";
                }

                if (value !== "") {
                    input.checked = (input.value === value);
                }
            } else {
                if (input.tagName === "SELECT") {
                    if ($("option[value='" + data[name] + "']", input).length > 0) {
                        input.value = data[name];
                    }
                } else {
                    input.value = data[name];
                }
            }

            // Reformat phone numbers, dollar amounts or state abbreviations
            if (input.type === "tel") {
                telephoneChangeListener.apply(input, [new Event("change")]);
            } else if (input.dataset.ruleDollars !== undefined) {
                jQuery.validator.methods.dollars.apply(undefined, [input.value, input]);
            } else if (input.dataset.ruleState !== undefined) {
                if (states[input.value] !== undefined) {
                    $(input).typeahead("val", states[input.value]);
                }
            }
        }
    }


    function validateOptionalEmail(this: JQueryValidation.Validator, value: any, element: HTMLElement) {
        element.removeAttribute("data-valid-email");

        if (/^\s*no\s*email\s*$/i.test(value)) {
            if (element instanceof HTMLInputElement) {
                element.value = "NO EMAIL";
            }
            element.setAttribute("data-valid-email", "true");
            return true;
        }


        if (jQuery.validator.methods.email.apply(this, arguments)) {
            element.setAttribute("data-valid-email", "true");
            return true;
        }

        return false;
    }

    jQuery.validator.addMethod(
        "emailNoEmail",
        validateOptionalEmail,
        "Please enter an email address or NO EMAIL"
    );

    function confirmEmail(this: JQueryValidation.Validator, value: any, element: HTMLElement, params: string) {
        const $target = $(params);

        if (!$target.attr("data-valid-email")) {
            return true;
        }

        return element instanceof HTMLInputElement
            && element.value.toLowerCase() === String($target.val()).toLowerCase();
    }

    jQuery.validator.addMethod("confirmEmail", confirmEmail);

    function confirmOptionalEmail(this: JQueryValidation.Validator, value: any, element: HTMLElement, params: string) {
        if (!validateOptionalEmail.apply(this, [value, element])) {
            return false;
        }

        return confirmEmail.apply(this, [value, element, params]);
    }

    jQuery.validator.addMethod(
        "confirmEmailNoEmail",
        confirmOptionalEmail,
        "Email addresses do not match. Please try again."
    );

    const dollarRegex = /^\s*\$?\s*\d+(,\d{3})*(\.\d\d)?$/;

    function validateDollarAmount(this: JQueryValidation.Validator, value: any, element: HTMLElement) {
        if (this !== undefined && this.optional(element)) {
            return true;
        }

        if (!dollarRegex.test(value)) {
            return false;
        }

        value = String(value).replace(/[^\d\.]/g, "");
        value = parseFloat(value);

        if (isNaN(value)) {
            return false;
        }

        if (element instanceof HTMLInputElement) {
            value = "$" + value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
            value = value.replace(/\.00$/, "");
            element.value = value;
        }

        return true;
    }

    jQuery.validator.addMethod(
        "dollars",
        validateDollarAmount,
        "Please enter a US$ dollar amount"
    );

    const dollarWithNegativeRegex = /^\s*-?\$?\s*\d+(,\d{3})*(\.\d\d)?$/;


    function validateDollarAmountAllowingNegative(
        this: JQueryValidation.Validator,
        value: any,
        element: HTMLElement
    ) {
        if (this !== undefined && this.optional(element)) {
            return true;
        }

        if (!dollarWithNegativeRegex.test(value)) {
            return false;
        }

        value = String(value).replace(/[^-\d\.]/g, "");
        value = parseFloat(value);

        if (isNaN(value)) {
            return false;
        }

        if (element instanceof HTMLInputElement) {
            let prefix = "$";

            if (value < 0) {
                value = -value;
                prefix = "-$";
            }

            value = prefix + value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
            value = value.replace(/\.00$/, "");
            element.value = value;
        }

        return true;
    }

    jQuery.validator.addMethod(
        "dollarsnegative",
        validateDollarAmountAllowingNegative,
        "Please enter a US$ dollar amount"
    );


    const $forms = $("form.needs-validation");

    $forms.on("submit", formSubmitListener);

    $forms.validate();
}